/**
 * EventForm constants
 */
export const FORM_NAME = 'eventForm';
